var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"checklist"},_vm._l((_vm.items),function(item){return _c('li',{key:item,staticClass:"checklist__item"},[_c('i',{staticClass:"fas fa-check-circle checklist__icon"}),(_vm.hasSlot(item))?[_vm._t(item)]:[_vm._v(_vm._s(item))]],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }